import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import MeetingRequest from '@/types/table/meetingRequest';
import { FilesManageData } from '@/api/generated/filesManageController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface MeetingRequestData extends MeetingRequest {
  filesManage?: FilesManageData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class MeetingRequestController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<MeetingRequestData>>(API_CONTEXT + '/app/meetingRequest/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<MeetingRequestData>(API_CONTEXT + '/app/meetingRequest/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/meetingRequest/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/meetingRequest/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/meetingRequest/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/startOnly/flowMeetingRequest', params, httpOptions);
  }
  static startWithBusinessKeyFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/startWithBusinessKey/flowMeetingRequest', params, httpOptions);
  }
  static startAndTakeUserTaskFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/startAndTakeUserTask/flowMeetingRequest', params, httpOptions);
  }
  static startAndSaveDraftFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/startAndSaveDraft/flowMeetingRequest', params, httpOptions);
  }
  static submitUserTaskFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/submitUserTask/flowMeetingRequest', params, httpOptions);
  }
  static viewTaskBusinessDataFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/meetingRequest/viewTaskBusinessData/flowMeetingRequest', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/meetingRequest/viewHistoricTaskBusinessData/flowMeetingRequest', params, httpOptions);
  }
  static listWorkOrderFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/meetingRequest/listWorkOrder/flowMeetingRequest', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}
